import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue"

import { ElTabs, ElTabPane } from 'element-plus';
import { TabType } from '~src/admin/types';
import { breakpointsTailwind, useBreakpoints } from '@vueuse/core';

// Props

export default /*@__PURE__*/_defineComponent({
  __name: 'Tabs',
  props: {
    tabs: {}
  },
  setup(__props: any) {



// Change tab position based on breakpoint
const breakpoints = useBreakpoints(breakpointsTailwind);
const isMobile = breakpoints.smaller('md');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ElTabs), {
    class: "tabs",
    "tab-position": _unref(isMobile) ? 'top' : 'left'
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab, i) => {
        return (_openBlock(), _createBlock(_unref(ElTabPane), {
          key: i,
          label: tab.label
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_resolveDynamicComponent(tab.content)))
          ]),
          _: 2
        }, 1032, ["label"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["tab-position"]))
}
}

})